import React from 'react';
import PropTypes from 'prop-types';
import { orderBy, filter } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';

import HomeCard from '../../components/HomeCard';
import { colors } from '../../styles';

const styles = css`
  display: flex;
  flex-direction: column;
  .CommunityHomes {
    h3 {
      font-weight: bold;
      font-size: 34px;
      color: ${colors.brand1};
      margin-bottom: 20px;
      text-align: center;
      font-weight: 500;
      @media(min-width: 992px) {
        font-size: 39px;
        letter-spacing: 1px;
        font-size: 45px;
        padding: 20px 0;
      }
    }
  }
  .CommunityHomes_list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .CommunityHomes_item {
      width: 361px;
      min-height: 635px;
      height: auto;
      margin: 10px;
      @media(min-width: 768px) {
        height: 635px;
        min-width: unset;
      }
    }
  }

  .ButtonDefault {
    min-width: 272px;
    cursor: pointer;
    margin: 30px auto 0;
  }
`;

const HomeDetailNearBy = ({ home, homes }) => {
  const AreaHomes = filter(homes, item => item._id !== home._id);
  return (
    <div className={styles}>
      <div className="CommunityHomes">
        <div className="CommunityHomes_list">
          {
            orderBy(AreaHomes, 'sqft', 'desc').slice(0, 3).map(item => (
              <div key={item._id} className="CommunityHomes_item">
                <HomeCard home={item} />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

HomeDetailNearBy.propTypes = {
  home: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  home: true,
  homes: true,
})(HomeDetailNearBy);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeDetailNearBy.js